/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Checkout/OrderConfirmation',[
    'global/all'
], function (Roc) {
    'use strict';

    var viewModel;

    function init(model) {
        Roc.UI.template('orderConfirmation-Tmp', model).then(function (renderedTemplate) {
            $('#orderConfirmationDetails').html(renderedTemplate);
        });

        viewModel = model;

        Roc.EventManager.notify(Roc.Events.cart.ORDER_CONFIRM, viewModel, true);
    };

    var OrderConfirmation = {
        init: init,
        viewModel: viewModel
    };

    Roc.Logger.debug('OrderConfirmation.js Loaded:', OrderConfirmation);

    return OrderConfirmation;
});

